import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { EXPORT_OPTIONS } from '../../constants';

export default function IcomesModal({
  show,
  onHide,
  exportOption,
  setExportOption,
  onConfirm,
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Opciones de descarga</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Check
            type="radio"
            label="Mes actual"
            name="exportOptions"
            value={EXPORT_OPTIONS.CURRENT}
            checked={exportOption === EXPORT_OPTIONS.CURRENT}
            onChange={() => setExportOption(EXPORT_OPTIONS.CURRENT)}
          />
          <Form.Check
            type="radio"
            label="Mes anterior"
            name="exportOptions"
            value={EXPORT_OPTIONS.PREVIOUS}
            checked={exportOption === EXPORT_OPTIONS.PREVIOUS}
            onChange={() => setExportOption(EXPORT_OPTIONS.PREVIOUS)}
          />
          <Form.Check
            type="radio"
            label="Filtros aplicados en gráfico"
            name="exportOptions"
            value={EXPORT_OPTIONS.FILTERS}
            checked={exportOption === EXPORT_OPTIONS.FILTERS}
            onChange={() => setExportOption(EXPORT_OPTIONS.FILTERS)}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="success" onClick={onConfirm}>
          Descargar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
